// @flow
import type { AxiosPromise, AxiosInstance } from "axios";

const loadUserVehicles = (): ((
  apiInstance: AxiosInstance
) => AxiosPromise<>) => (apiInstance) => {
  return apiInstance.get(`/v4/users/vehicles`);
};

export default loadUserVehicles;
